import { useCallback, useMemo } from 'react';
import selectors from '../../../common/constants/selectors';

const units = {
  PERCENTS: 'PERCENTS',
  PIXELS: 'PIXELS',
};

const useWidthCalculator = ({ element }) => {
  const initialUnit = useMemo(() => {
    const widthAttr = element.getAttribute('width');

    if (widthAttr?.endsWith('%') || element.matches(selectors.COMPOSITE_ITEM)) {
      return units.PERCENTS;
    }

    return units.PIXELS;
  }, [element]);

  const calculateWidth = useCallback(
    ({ width, parentWidth }) => {
      if (initialUnit === units.PIXELS) {
        return `${width}px`;
      }

      return `${((width / parentWidth) * 100).toFixed(8)}%`;
    },
    [initialUnit]
  );

  return { calculateWidth };
};

export default useWidthCalculator;
